import React from "react";
import { Box, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";

import Spacer from "components/Spacer";
import PercentageIndicator from "components/visuals/PercentageIndicator";

import { selectors } from "modules/customer/insights/portfolio/performanceDrivers/storeSize";

const PropertyCostsPerSquareFootVariance = () => {
    const propertyCostsPerSquareFootVariance = useSelector(state => selectors.propertyCostsPerSquareFootVariance(state));
    const { loading, error, value } = propertyCostsPerSquareFootVariance;
    const label = "% variance from median";

    return (
        <Box display="flex" data-cy="property-costs-per-square-foot-variance">
            <Typography variant="body1">{label}</Typography>
            <Spacer />
            <PercentageIndicator loading={loading} error={error} align="right" showIndicator={false} value={value} 
            switchColor={true} />
        </Box>
    );
};

export default PropertyCostsPerSquareFootVariance;
